module.exports = __webpack_public_path__ + "public/Icons/addNewIcon.svg?b4d3afdb";